import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { NXFilter, NXSearch, NXRefresh } from "../../icons";
import { DateRangePickesrButton, InputField } from "../common";
import moment from "moment";

interface ToolbarProps {
  onDateRangeApply?: (ranges: any) => void;
  onFilterOpen?: () => void;
  onClearFilters?: () => void;
  onRefresh?: () => void;
  startDateKey?: string;
  endDateKey?: string;
}

function SearchAndFilterToolbar({ onDateRangeApply, onFilterOpen, onClearFilters, onRefresh, startDateKey, endDateKey }: ToolbarProps) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState<string>("");

  useEffect(() => {
    const initialSearch = searchParams.get("search") || "";
    setSearchValue(initialSearch);
  }, [searchParams]);

  const handleClearFilters = () => {
    onClearFilters && onClearFilters();
    const newParams = new URLSearchParams();
    newParams.set("first", "20"); // graphql pagination
    navigate({
      pathname: window.location.pathname,
      search: newParams.toString(),
    });
  };

 
  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);

    const newParams = new URLSearchParams(searchParams);
    if (value) {
      newParams.set("search", value);
    } else {
      newParams.delete("search");
    }
    setSearchParams(newParams);
  };

  const datePickerDefaultValues = {
    startDate: searchParams.get(startDateKey || "") || null,
    endDate: searchParams.get(endDateKey || "") || null,
    key: "selection",
  };

  const onDateRangeApplyHandler  = (range: any) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", "1"); 

    const formattedStartDate = moment(range?.startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(range?.endDate).format('YYYY-MM-DD');

    newParams.set(startDateKey || "", formattedStartDate);
    newParams.set(endDateKey || "", formattedEndDate);
    setSearchParams(newParams);
}

  return (
    <div className="flex flex-col mt-2 xl:mt-0 gap-2 px-2 xl:gap-5 xl:py-5 xl:flex xl:flex-row xl:items-center xl:justify-between border-b border-[#EEEFF2]">
      <div className="relative w-full xl:w-[60%]">
        <NXSearch className="absolute top-1/2 left-4 transform -translate-y-1/2" />
        <InputField
          type="text"
          placeholder="Search by ID, product, or others..."
          onChange={onSearch}
          value={searchValue}
          className="p-[12px] bg-secondary-50 rounded-lg border-none outline-none ps-[3.1rem] w-full"
        />
      </div>
      <div className="flex gap-2 justify-center">
        {onFilterOpen &&  <button
          onClick={onFilterOpen}
          className="flex items-center gap-2 bg-secondary-50 px-4 py-3 rounded-md text-base-300"
        >
          <NXFilter className="rotate-90"/>
          <span className="hidden ml:block md:text-sm xl:text-base">Filters</span>
        </button>}
       

        <DateRangePickesrButton defaultValue={datePickerDefaultValues} onApply={onDateRangeApply ? onDateRangeApply : onDateRangeApplyHandler} initialLabel="Select Date" />

        {/* <button
          className="flex items-center gap-2 bg-secondary-50 px-4 py-3 rounded-md text-base-300"
        >
          <NXDownload />
          <span className="hidden ml:block md:text-sm xl:text-base">Download</span>
        </button> */}

        {/* Clear Filters Button */}
        <button
          onClick={handleClearFilters}
          className="flex items-center gap-2 bg-secondary-50 px-4 py-3 rounded-md text-base-300"
        >
            <NXFilter className="text-red-500 rotate-90" />
          <span className="hidden ml:block md:text-sm xl:text-base">Clear</span>
        </button>
          
          {/* Refresh Button */}
        {onRefresh && <button
          onClick={onRefresh}
          className="flex items-center gap-2 bg-secondary-50 px-4 py-3 rounded-md text-base-300"
        >
          <NXRefresh />
          <span className="hidden ml:block md:text-sm lg:text-base">Refresh</span>
        </button>
        }
        
      </div>
    </div>
  );
}

export default SearchAndFilterToolbar;
